import { render, staticRenderFns } from "./CreateCampaign.ts.vue?vue&type=template&id=0dd6a249"
import script from "./CreateCampaign.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateCampaign.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateCampaign.ts.vue?vue&type=style&index=0&id=0dd6a249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports